export default __webpack_public_path__ + "static/media/VOSE.1330d15a.png";